// extracted by mini-css-extract-plugin
export var cancelButton = "_or-5";
export var content = "_or-3";
export var createButton = "_or-6";
export var drawerContainer = "_or-0";
export var footer = "_or-2";
export var header = "_or-1";
export var orderFormColumn = "_or-4";